/**
 * Created by coolguy on 2017/11/17.
 */
import * as R from 'ramda';
import intl from 'react-intl-universal';

import stat from './stat';
import URLUtil from './url';
import base64 from './base64';
import request from './request';
import cookieUtil from './cookie';
import {
  appendCurrentShareRouteParams,
  appendShareLangToUrl,
  decorateShareTitleForCurrentContext,
  getEffectiveShareImageKey,
  getEffectiveShareText,
  getEffectiveShareTitle,
} from './shareMeta';

let needToReset = false;
let lastGlobalShare = {};
let js_api = {};

const hasOwn = (obj, key) => {
  return !!obj && Object.prototype.hasOwnProperty.call(obj, key);
};

const hasShareFields = (share = {}) => {
  return ['title', 'image', 'url', 'desc'].some((key) => {
    return hasOwn(share, key) && typeof share[key] !== 'undefined';
  });
};

export const getTitle = () => {
  return getEffectiveShareTitle();
};

export const getShareUrl = (useRoot) => {
  let { url_labeling } = window.gallery;
  // 一个西安杨森的定制需求
  // 可以去掉了 2022-12-19
  // if (String(window.gallery.id) == '1007543') {
  //   return 'http://live.jfoto.cn/page/enterprize/gallery/d6b33e96';
  // }

  const ivParam =
    window.configDetail && Number(window.configDetail.use_invite_link)
      ? `&iv=${window.userinfo.openid}`
      : ``;

  // 再加一个规则，如果pageDetail里设置了分享信息，则直接使用 2019-11-19
  let { h5_share_image, h5_share_text, h5_share_title, h5_share_link } =
    window.pageDetail;
  if (h5_share_link) {
    if (h5_share_link.indexOf('http') === 0) {
      const urlParse = URLUtil(h5_share_link);
      urlParse.setParam('iv', window.userinfo.openid);
      urlParse.setParam('from', 'groupmessage');
      return appendShareLangToUrl(
        appendCurrentShareRouteParams(urlParse.toString())
      );
    } else {
      return appendShareLangToUrl(
        appendCurrentShareRouteParams(
          `${window.location.protocol}//${window.__hostname}/g/${h5_share_link}?from=groupmessage${ivParam}`
        )
      );
    }
  } else if (h5_share_text && h5_share_image && h5_share_title) {
    return appendShareLangToUrl(
      appendCurrentShareRouteParams(
        `${window.location.protocol}//${window.__hostname}/g/${window.pageDetail.link_id}?from=groupmessage${ivParam}`
      )
    );
    // 再加一个规则，dataDetail 与 gallery 不是同一个 2019-09-26
  } else if (
    window.dataDetail &&
    window.dataDetail.name &&
    window.dataDetail.id != window.gallery.id &&
    window.pageDetail
  ) {
    if (!useRoot) {
      return appendShareLangToUrl(
        appendCurrentShareRouteParams(
          `${window.location.protocol}//${window.__hostname}/g/${window.pageDetail.link_id}?from=groupmessage${ivParam}`
        )
      );
    }
  }
  return appendShareLangToUrl(
    appendCurrentShareRouteParams(
      `${window.location.protocol}//${window.__hostname}/gti/${url_labeling}?from=groupmessage${ivParam}`
    )
  );
};


export const buildShareImageUrl = (image) => {
  if (!image) {
    return '';
  }
  // Guest avatars may already contain a host without a protocol.
  // Resolve them before treating the value as a CDN object key.
  if (image.indexOf('//') === 0) {
    return `https:${image}`;
  }
  if (image.indexOf('http') === 0) {
    return image;
  }
  return `https://${window.configDetail.use_global * 1 ? 'iglobal1' : 'image1'}${window.__basename}/${image}`;
}

export const getShareImage = () => {
  const h5_share_image = getEffectiveShareImageKey();

  return (
    'https://' +
    (window.configDetail.use_global * 1 ? 'iglobal1' : 'image1') +
    window.__basename +
    '/' +
    h5_share_image
  );
};

export const getShareText = () => {
  return getEffectiveShareText();
};

export const getShareConfig = (share = {}) => {
  const shareOptions = share && typeof share === 'object' ? share : {};
  const { useRoot } = shareOptions;
  const result = {
    ...shareOptions,
  };

  delete result.useRoot;

  if (!hasOwn(shareOptions, 'title') || typeof shareOptions.title === 'undefined') {
    result.title = getTitle();
  }

  if (!hasOwn(shareOptions, 'image') || typeof shareOptions.image === 'undefined') {
    result.image = getShareImage();
  }

  if (!hasOwn(shareOptions, 'url') || typeof shareOptions.url === 'undefined') {
    result.url = getShareUrl(useRoot);
  }

  if (!hasOwn(shareOptions, 'desc') || typeof shareOptions.desc === 'undefined') {
    result.desc = getShareText();
  }

  result.url = appendCurrentShareRouteParams(result.url);
  result.title = decorateShareTitleForCurrentContext(result.title);

  return result;
};

export const getQueryShareData = (url = '') => {
  let shareQuery = { t: '', i: '', d: '' };
  url = url || window.location.href;
  let urlParse = URLUtil(url);
  if (urlParse && urlParse.getParam('_s')) {
    try {
      const base64Result = base64.safeDecode(
        decodeURIComponent(decodeURIComponent(urlParse.getParam('_s')))
      );
      shareQuery = JSON.parse(base64Result);
    } catch (e) {
      console.error(e);
    }
  }

  return shareQuery;
};

const appendQuery = (url, key, value, removeHash) => {
  let parse = URLUtil(url);
  parse.setParam(key, value);
  if (removeHash) {
    parse.anchor = null;
  }
  return parse.toString();
};

const wxUtil = {
  getStorageSync: function (key) {
    let result = localStorage[key];
    try {
      result = JSON.parse(result);
    } catch (e) { }
    return result;
  },
  setStorage: function ({ key, data }) {
    localStorage[key] = data;
  },
  navigateBack: () => {
    window.history.back();
  },
  navigateTo: (obj = {}, history) => {
    //console.log('navigateTo',obj);
    const { url } = obj;
    if (history) {
      history.push(url);
    } else {
      console.warn('history is null', url);
    }
  },
  navigateReplace: (obj = {}, history) => {
    const { url } = obj;
    if (history) {
      history.replace(url);
    } else {
      console.warn('history is null in replace', url);
    }
  },
  redirectTo: (obj = {}, history) => {
    const { url } = obj;
    if (history) {
      history.replace(url);
    } else {
      console.warn('history is null', url);
    }
  },
  showShareLimitTip: function (callback) {
    // 直接DOM操作了
    let share = window.document.createElement('div');
    share.className = 'person-share-modal';

    share.innerHTML = `
      <div class="wrapper">
        <div class="content">
          <img src="//image1${window.__basename}/static/person-share-limit.png" />
        </div>
      </div>
    `;

    window.document.body.appendChild(share);

    share.addEventListener('click', () => {
      window.document.body.removeChild(share);

      if (callback) {
        callback();
      }
    });
  },
  showShareTip: function (shareUrl, uiStore, callback, simple) {
    // 直接DOM操作了
    let share = window.document.createElement('div');
    share.className = 'person-share-modal';

    share.innerHTML = `
      <div class="wrapper">
        <div class="content">
          <img src="//image1${window.__basename}/static/person-share${simple ? '-simple' : ''
      }.png" />
          <a class="copylink">${shareUrl}</a>
        </div>
      </div>
    `;

    window.document.body.appendChild(share);

    let copy = share.querySelector('a');
    if (copy) {
      copy.addEventListener('click', () => {
        if (copy) {
          let range = document.createRange();
          range.selectNode(copy);

          let selection = window.getSelection();
          if (selection) {
            selection.empty();
            selection.addRange(range);
            document.execCommand('Copy');
            selection.empty();
            range.detach();
            // @ts-ignore
            range = null;

            uiStore.showToast({
              content: intl.get('Copyed'),
              time: 1000,
            });
          }
        }
        stat.event('share');
      });
    }

    share.addEventListener('click', () => {
      window.document.body.removeChild(share);

      if (callback) {
        callback();
      }
    });
  },
  configPersonShare: function (personid, defaultData = {}) {
    const hasImageInDefaultData = R.hasPath(['image'], defaultData);
    let image = '';
    if (hasImageInDefaultData) {
      image = decodeURIComponent(defaultData.image);
      if (image.startsWith('//')) {
        image = image.replace('//', 'https://');
      }
    }

    const nickname =
      window.userinfo && window.userinfo.nickname
        ? window.userinfo.nickname
        : null;
    const shareFromAvatar = defaultData.avatar || '';
    const url = `${window.location.protocol}//${window.location.hostname}/page/person/${window.pageDetail.link_id}/${personid}/${window.userinfo.openid}?avatar=${shareFromAvatar}`;
    let share = {
      url,
      title:
        defaultData.title ||
        `来自好友${nickname ? `（${nickname}）` : ''}的影集分享`,
      image: image || getShareImage(),
      desc: defaultData.desc || `好友分享给您的照片，请查看`,
    };
    // console.info('share', share);

    needToReset = true;
    wxUtil.__callConfig(
      share,
      base64.safe(
        JSON.stringify({
          t: share.title,
          i: share.image,
          d: share.desc,
        })
      )
    );

    return share;
  },
  configImageShare: function (imageids, defaultData = {}) {
    console.log(defaultData);
    //  选照片分享, 也就是选图分享
    let share = {
      url: `${window.location.protocol}//${window.location.hostname}/page/share/${window.userinfo.openid}/${imageids}`,
      title: defaultData.title || `这些照片不错，一起看看呀!`,
      image: defaultData.image || getShareImage(),
      desc: defaultData.desc || `好友分享给您的照片，请查看`,
    };

    needToReset = true;
    wxUtil.__callConfig(share);

    return share;
  },
  __callConfig: function (share, shareEncode = '') {
    let url = shareEncode
      ? appendQuery(share.url, '_s', shareEncode)
      : share.url;
    url = appendShareLangToUrl(url);
    if (window.wx) {
      let timelineUrl = appendQuery(url, 'from', 'timeline', true);
      // window.wx.onMenuShareTimeline({
      // window.wx.updateTimelineShareData && window.wx.updateTimelineShareData({
      //   title: share.title,
      //   link: timelineUrl,
      //   imgUrl: share.image,
      //   success: () => {
      //     stat.event('share');
      //   },
      // });

      let messageUrl = appendQuery(url, 'from', 'groupmessage', true);
      // window.wx.onMenuShareAppMessage({
      // window.wx.updateAppMessageShareData && window.wx.updateAppMessageShareData({
      //   title: share.title,
      //   desc: share.desc,
      //   link: messageUrl,
      //   imgUrl: share.image,
      //   success: () => {
      //     stat.event('share');
      //   },
      // });

      let workUrl = appendQuery(url, 'from', 'wxwork', true);
      const timelineAction = window.isweixinwork
        ? window.wx.onMenuShareTimeline
        : window.wx.updateTimelineShareData;
      const messageAction = window.isweixinwork
        ? window.wx.onMenuShareAppMessage
        : window.wx.updateAppMessageShareData;
      if (messageAction) {
        messageAction({
          title: share.title,
          desc: share.desc,
          link: window.isweixinwork ? workUrl : messageUrl,
          imgUrl: share.image,
          success: () => {
            stat.event('share');
          },
          fail: (e) => {
            console.error(e);
          },
        });
      }

      if (timelineAction) {
        timelineAction({
          title: share.title,
          link: window.isweixinwork ? workUrl : timelineUrl,
          imgUrl: share.image,
          success: () => {
            stat.event('share');
          },
        });
      }

      if (window.isweixinwork) {
        window.wx.onMenuShareWechat({
          title: share.title,
          desc: share.desc,
          link: messageUrl,
          imgUrl: share.image,
          enableIdTrans: 1, // 是否开启id转译，不填默认为0
          success: function () {
            stat.event('share');
          },
        });
        //   let workUrl = appendQuery(share.url, 'from', 'wxwork');
        //   window.wx.onMenuShareTimeline({
        //     title: share.title,
        //     link: workUrl,
        //     imgUrl: share.image,
        //     success: () => {
        //       stat.event('share');
        //     },
        //   });

        //   window.wx.onMenuShareAppMessage({
        //     title: share.title,
        //     desc: share.desc,
        //     link: workUrl,
        //     imgUrl: share.image,
        //     success: () => {
        //       stat.event('share');
        //     },
        //   });
      }
    }
  },
  configShare: function (share, callback) {
    if (typeof share == 'undefined') {
      share = hasShareFields(lastGlobalShare)
        ? lastGlobalShare
        : getShareConfig();
    } else {
      share = getShareConfig(share);
      lastGlobalShare = share;
    }
    if (!window.has_config_share || needToReset) {
      if (share && share.url && share.url.indexOf('http') != 0) {
        // fixed 一次协议
        share.url = window.location.protocol + share.url;
      }

      if (needToReset) {
        wxUtil.__callConfig(share);
      } else {
        if (window.isweixin) {
          request({
            // url: '/api/common/signature',
            url: '/api/v2/user/signature',
            // method: 'post',
            method: 'get',
            body: {
              url: encodeURIComponent(window.location.href),
              // url: encodeURIComponent(share.url)
            },
          })
            .then((res) => {
              if (res.success) {
                js_api = res.data;
                if (window.wx) {
                  var debug = false;
                  window.wx.config({
                    debug: debug,
                    beta: window.isweixinwork,
                    appId: js_api.appid,
                    timestamp: js_api.timestamp,
                    nonceStr: js_api.noncestr,
                    signature: js_api.signature,
                    jsApiList: [
                      'onMenuShareTimeline',
                      'onMenuShareAppMessage',
                      'updateTimelineShareData',
                      'updateAppMessageShareData',
                      'getNetworkType',
                      'scanQRCode',
                      'chooseWXPay',
                      'openLocation',
                      'openProductSpecificView',
                      'addCard',
                      'chooseCard',
                      'openCard',
                      'hideAllNonBaseMenuItem',
                      'chooseWXPay',
                      'hideMenuItems',
                      'showMenuItems',
                      'hideAllNonBaseMenuItem',
                      'showAllNonBaseMenuItem',
                    ],
                    openTagList: ['wx-open-launch-weapp'],
                  });

                  window.wx.error(function (res) {
                    console.error(res);
                  });

                  const eventInvoke = function () {
                    if (share) {
                      wxUtil.__callConfig(share);

                      let disableShare = cookieUtil.getItem(
                        'disableshare_' + window.gallery.id
                      );
                      if (disableShare || window.__disable_share) {
                        window.wx.hideMenuItems({
                          menuList: [
                            // 'menuItem:share:timeline',
                            // 'menuItem:share:qq',
                            // 'menuItem:share:wechat',
                            // 'menuItem:share:weiboApp',
                            // 'menuItem:favorite',
                            // 'menuItem:share:facebook',
                            // 'menuItem:share:QZone',
                            // 'menuItem:editTag',
                            // 'menuItem:delete',
                            // 'menuItem:copyUrl',
                            // 'menuItem:originPage',
                            // 'menuItem:readMode',
                            // 'menuItem:openWithQQBrowser',
                            // 'menuItem:openWithSafari',
                            // 'menuItem:share:email',
                            // 'menuItem:share:brand',
                            'menuItem:share:appMessage',
                            'menuItem:share:timeline',
                            'menuItem:share:qq',
                            'menuItem:share:weiboApp',
                            'menuItem:share:facebook',
                            'menuItem:share:QZone',
                            'menuItem:copyUrl',
                            'menuItem:openWithQQBrowser',
                            'menuItem:openWithSafari',
                            'menuItem:share:email',
                          ], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                        });
                        window.wx.hideAllNonBaseMenuItem();
                      }
                    }

                    callback && callback();
                  };

                  window.wx.ready(function () {
                    // eventInvoke();
                    if (window.WeixinJSBridge) {
                      eventInvoke();
                    } else {
                      window.document.addEventListener(
                        'WeixinJSBridgeReady',
                        eventInvoke
                      );
                    }
                  });
                }

                window.has_config_share = true;
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } else if (window.dd) {
          try {
            window.dd.ready(() => {
              window.dd.biz.navigation.setRight({
                show: true,
                control: true,
                text: '分享',
                onSuccess: function (result) {
                  window.dd.biz.util.share({
                    type: 0, //分享类型，0:全部组件 默认； 1:只能分享到钉钉；2:不能分享，只有刷新按钮
                    title: share.title,
                    content: share.desc,
                    url: share.url,
                    image: share.image,
                  });
                  window.has_config_share = true;
                },
                onFail: function (err) { },
              });
            });
          } catch (e) { }
        }
      }

      needToReset = false;
    }
  },
  getTitle: getTitle,
  getShareUrl: getShareUrl,
  getShareImage: getShareImage,
  getShareText: getShareText,
  getShareConfig: getShareConfig,
};

export default wxUtil;
